<template>
  <div>
  <div v-if="false"
       :style="`height:${height}px; border: none;`">
    <iframe
      :src="policyPathUrl"
      :title="policyTitle"
      width="100%"
      height="100%"
    />
  </div>
    <div
        style="overflow-y: scroll;
        height:200px;">
      <policy-privacy
          :resource="resource"
      />
    </div>

  </div>
</template>

<script>
import EventLog from "@/mixins/resourceBlocks/EventLog";
import Player from "@/components/common/player";
import PolicyPrivacy  from './policies/privacy';

export default {
  name: "AboutIntro_Policy",
  mixins: [EventLog],
  components: {
    Player,
    PolicyPrivacy
  },
  props: {
    resource: {
      type: Object,
      default: () => {}
    },
    height: {
      type: Number,
      default: 300
    },
    policyType: {
      type: String,
      default: "terms"
    },
    policyPathUrl: {
      type: String,
      default: "/policy/terms"
    },
    policyTitle: {
      type: String,
      default: "D3rriana URL"
    }
  },
  computed: {},
  methods: {},
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped></style>
